export const COLORS = {
  primary: '#EB0A1E',
  blue: '#3b82f6',
  green: '#10b981',
  red: '#ef4444',
  orange: '#f59e0b',
  purple: '#8b5cf6',
  dark: '#0f172a',
  darkText: '#0f172a',
  secondaryText: '#64748b',
  cardBg: '#ffffff',
  pageBg: '#f8fafc',
  border: '#e2e8f0',
  borderLight: '#f1f5f9',
  shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.05)',
  shadowLg: '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -4px rgba(0,0,0,0.04)',
};

/* ── Keyframes for dashboard animations ── */
export const FADE_UP_KEYFRAMES = {
  '@keyframes fadeUp': {
    '0%': { opacity: 0, transform: 'translateY(18px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
  },
};

export const fadeUpSx = (delay = 0) => ({
  ...FADE_UP_KEYFRAMES,
  animation: `fadeUp 0.45s cubic-bezier(0.23, 1, 0.32, 1) ${delay}s both`,
});

export const ENV_PALETTE: Record<string, string> = {
  DEV: '#3b82f6',
  PROD: '#ef4444',
  QA: '#f59e0b',
  '(BLANK)': '#94a3b8',
};

export const CHART_CARD_SX = {
  bgcolor: COLORS.cardBg,
  borderRadius: '12px',
  boxShadow: COLORS.shadow,
  border: `1px solid ${COLORS.border}`,
  p: 2.5,
  height: '100%',
  transition: 'box-shadow 0.25s ease, transform 0.25s ease',
  '&:hover': { boxShadow: COLORS.shadowMd, transform: 'translateY(-2px)' },
  ...FADE_UP_KEYFRAMES,
  animation: 'fadeUp 0.5s cubic-bezier(0.23, 1, 0.32, 1) both',
};

export const SECTION_HEADER_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 2,
  mt: 3.5,
  pl: 1.5,
  borderLeft: `3px solid ${COLORS.primary}`,
};

export const TOOLTIP_STYLE = {
  backgroundColor: '#fff',
  border: `1px solid ${COLORS.border}`,
  borderRadius: '8px',
  boxShadow: COLORS.shadowMd,
  fontSize: 12,
  padding: '8px 12px',
};

export const SUMMARY_COLORS = [
  COLORS.blue,
  COLORS.green,
  COLORS.red,
  COLORS.orange,
  COLORS.purple,
  COLORS.dark,
];

export const CHART_COLORS = [
  '#3b82f6', '#6366f1', '#10b981', '#f59e0b', '#8b5cf6', '#06b6d4',
  '#ec4899', '#14b8a6', '#f97316', '#0ea5e9',
];
